import { SET_COMPANYDETAILLIST } from '../actions';

const companydetails = (state = [], action) => {
  switch (action.type) {
	case SET_COMPANYDETAILLIST:
      return [...action.value];  
    default: return state;
  }
}

export default companydetails;
